/* ----------------------------------------------------
Project: Dental-Website
Component: Post (Blog Card)
Author: DCPL Technology Private Limited
-------------------------------------------------------- */

import React from "react";
import Image from "next/image";
import Link from "next/link";
import "./index.css";
import { AeroIcon } from "@/utlility/icons";
import { colors } from "@/app/Colors";
import BlogChip from "../blog-chip/BlogChip";

const Post = ({ image, title, auther, date, link = "#" }) => (
  <Link
    href={`/${link}`}
    className="comman-blog position-relative cursor-pointer text-decoration-none d-block"
  >
    {/* Blog Background Image */}
    <Image
      src={image}
      alt={title || "blog-image"}
      width={413}
      height={550}
      priority={false}
    />

    {/* Content Overlay */}
    <div className="position-absolute top-0 start-0 w-100 h-100 text-box p-4">
      <div className="d-flex flex-column justify-content-between h-100 w-auto">
        {/* Author & Date Chip */}
        <div>
          <BlogChip name={auther} date={date} />
        </div>

        {/* Title and Action Icon */}
        <div className="d-flex title">
          <h3 className="fw-bold blog-title">{title}</h3>
          <div className="icon-cover">
            <i className="icon">
              <AeroIcon color={colors["--text-primary"]} />
            </i>
          </div>
        </div>
      </div>
    </div>
  </Link>
);

export default Post;
